/** An empty/whitespace wire string becomes null in the domain (optional fields). */
export const emptyToNull = (v: string): string | null => {
  const trimmed = v.trim();
  if (trimmed === "") {
    return null;
  }
  return trimmed;
};
